import React from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { useIntl } from "react-intl";

import {
  EntitiesSupportingGroups,
  EntityTypeSupportingGroups,
} from "@mapmycustomers/shared/types/entity";

import EntityTag from "@app/component/EntityTag";
import ListWithOverflowItem from "@app/component/ListWithOverflowItem";

import styles from "./Groups.module.scss";

interface Props {
  className?: string;
  entity: EntitiesSupportingGroups;
  entityType: EntityTypeSupportingGroups;
}

const GroupsSelection: React.FC<Props> = ({ className, entity }) => {
  const intl = useIntl();

  if (!entity.groups?.length) {
    return null;
  }

  return (
    <>
      <div className={cn(styles.container, className)}>
        <div className={styles.labelContainer}>
          <span className={styles.label}>
            {intl.formatMessage({
              id: "recordPane.groups.label",
              defaultMessage: "Groups",
              description: "Groups select label for a Preview pane",
            })}
          </span>
        </div>
        <div className={styles.groupListContainer}>
          <ListWithOverflowItem className={styles.groupList}>
            {(entity.groups ?? []).map((group) => (
              <EntityTag entity={group} key={group.id} />
            ))}
          </ListWithOverflowItem>
          <FontAwesomeIcon className={styles.groupListIcon} icon={faLock} />
        </div>
      </div>
    </>
  );
};

export default GroupsSelection;
